<template>
  <main id="wizard-frame">
    <AppAlerts />
    <WaveBackground id="wave-background" />
    <v-spacer />
    <DpplSignupLogoutButton
      v-if="authData.isLoggedIn"
      id="logout-button"
      href="/logout"
    >
      Log Out
    </DpplSignupLogoutButton>
    <router-view
      v-slot="{ Component }"
      @track-page-load="$emit('track-page-load', $event)"
    >
      <component :is="Component" />
    </router-view>
  </main>
</template>

<script>
import { mapState } from 'pinia';
import { useAppAuthData } from '@/stores/app/authData';
import AppAlerts from '@/components/shared/alerts/AppAlerts.vue';
import DpplSignupLogoutButton from '@/components/datapeople/DpplSignupLogoutButton.vue';
import WaveBackground from '@/components/signup/WaveBackground.vue';

export default {
  name: 'WizardFrame',
  components: { AppAlerts, DpplSignupLogoutButton, WaveBackground },
  emits: ['track-page-load'],
  computed: {
    ...mapState(useAppAuthData, ['authData']),
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
@import '@/less/mixins';

#wizard-frame {
  width: 100%;
  height: 100%;
  max-height: 100vh;
  overflow-y: auto;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: @text-darkest;
  background: @white;
  position: relative
}

#logout-button {
  position: absolute;
  top: 36px;
  right: 36px;
  width: 157px;
  .shadow();

  :deep(.v-btn__content) {
    color: @text-darkest;
    font-size: 16px;
    font-weight: 500;
    line-height: 19px;
  }
}
.logo {
  display: block;
  width: 120px;
  height: auto;
}

#wave-background {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
}
</style>
